export const getSpeedometerValues = (reportDetails) => {
    let speedometerData, mediumRiskGradeData = getMediumRiskLevelData(reportDetails),
        lowriskGradeData = getLowRiskLevelData(reportDetails),
        highRiskGradeData = getHighRiskLevelData(reportDetails);

    speedometerData = {
        totalScore: reportDetails.totalScore,
        min: reportDetails.riskGradeSummaryList[0].min,
        max: reportDetails.riskGradeSummaryList[reportDetails.riskGradeSummaryList.length - 1].max,
        mediumRiskValue: (mediumRiskGradeData.length > 0) ? {
            min: mediumRiskGradeData[0].min,
            max: mediumRiskGradeData[mediumRiskGradeData.length - 1].max
        } : {
                min: reportDetails.riskGradeSummaryList[0].min,
                max: reportDetails.riskGradeSummaryList[0].min
            },
        lowRiskValue: (lowriskGradeData.length > 0) ? {
            min: lowriskGradeData[0].min,
            max: lowriskGradeData[lowriskGradeData.length - 1].max
        } : {
                min: reportDetails.riskGradeSummaryList[0].min,
                max: reportDetails.riskGradeSummaryList[0].min,
            },
        highRiskValue: (highRiskGradeData.length > 0) ? {
            min: highRiskGradeData[0].min,
            max: highRiskGradeData[highRiskGradeData.length - 1].max
        } : {
                min: reportDetails.riskGradeSummaryList[0].min,
                max: reportDetails.riskGradeSummaryList[0].min,
            }
    }
    return speedometerData;
}

const getMediumRiskLevelData = (reportDetails) => {
    let mediumRiskGrade = [];
    reportDetails.riskGradeSummaryList.forEach(item => {
        if (item.riskLevel === 'MEDIUM') {
            mediumRiskGrade.push(item)
        }
    })
    return mediumRiskGrade
}
const getLowRiskLevelData = (reportDetails) => {
    let lowRiskGrade = [];
    reportDetails.riskGradeSummaryList.map(item => {
        if (item.riskLevel === 'LOW') {
            lowRiskGrade.push(item)
        }
    })
    return lowRiskGrade
}
const getHighRiskLevelData = (reportDetails) => {
    let highRiskGrade = [];
    reportDetails.riskGradeSummaryList.map(item => {
        if (item.riskLevel === 'HIGH') {
            highRiskGrade.push(item)
        }
    })
    return highRiskGrade
}
export const getRampValues = (rampRawData) => {
    let totalScaleDifference = rampRawData.max - rampRawData.min, rampValues;
    rampValues = {
        highData: ((rampRawData.highRiskValue.max - rampRawData.highRiskValue.min) / totalScaleDifference).toFixed(1),
        mediumData: (((rampRawData.mediumRiskValue.max - rampRawData.mediumRiskValue.min) / totalScaleDifference) + ((rampRawData.highRiskValue.max - rampRawData.highRiskValue.min) / totalScaleDifference)).toFixed(1),
        lowData: (((rampRawData.lowRiskValue.max - rampRawData.lowRiskValue.min) / totalScaleDifference) + ((rampRawData.mediumRiskValue.max - rampRawData.mediumRiskValue.min) / totalScaleDifference) + ((rampRawData.highRiskValue.max - rampRawData.highRiskValue.min) / totalScaleDifference)).toFixed(1)
    }
    return rampValues
}